import { backendBaseUrl, backendIntegrationBaseUrl, dashboardBaseUrl } from "../../configs/environment";


export const apiV1Endpoint = `${backendBaseUrl}/api/v1`;
export const integrationApiV1Endpoint = `${backendIntegrationBaseUrl}/api/v1`;
export const dashboardApiV1Endpoint = `${dashboardBaseUrl}/api/v1`;
